import React from "react";

const Header = () => {
  const headerStyle = {
    backgroundColor: "#1d3557", // 진한 파란색
    color: "white",
    padding: "15px",
    textAlign: "left",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  };

  const titleStyle = {
    margin: "0",
    fontSize: "1.5rem",
    fontWeight: "bold",
  };

  return (
    <header style={headerStyle}>
      <h1 style={titleStyle}>OSI 7계층 패킷 시뮬레이터</h1>
    </header>
  );
};

export default Header;
